import { KeyValuePair } from './KeyValuePair';

/**
 * Envio de movimentos por e-mail (Relatórios > Movimentos > Movimentos).
 * O mesmo filtro serve a pré-visualização, o PDF de cada destinatário e o envio, para o que se vê ser
 * exactamente o que se envia. @claude
 */

/** Tipo de envio: os Ids são os da opção escolhida no menu (acções 2452 e 2453). @claude */
export enum ENUM_MOVEMENT_NOTIFICATION_TYPE {
	FEDERATION = 1,
	SECTION = 3
}

/** Filtro enviado ao BE em `filter` (mesma forma que o envio já usava). @claude */
export interface IMovementNotificationFilter {
	IdCountry: number;
	IdDistrict: number;
	IdSection: number;
	IdCore: number;
	SectionType: number;
	Structures: Array<any>;
	MilitantSituations: Array<any>;
	SituationReasons: Array<any>;
	PageBreak: KeyValuePair;
	OrderBy: KeyValuePair;
	Format: KeyValuePair;
	PaidQuota: boolean;
	SectionInfo: number;
	Gender: any;
	Age: number;
	AdmissionStartDate: string;
	AdmissionEndDate: string;
	StartDate: string;
	EndDate: string;
}

/** Destinatário devolvido por movements/notification-preview. @claude */
export interface IMovementNotificationPreviewItem {
	/** Id a mandar em selectedIds: federação no envio às federações, secção no envio às secções. */
	IdTarget: number;
	IsFederation: boolean;
	/** 0 no envio às secções. */
	IdFederation: number;
	/** null no envio às secções. */
	FederationDescription: string | null;
	/** 0 no envio às federações. */
	IdSection: number;
	SectionDescription: string | null;
	/** Concelhia da secção; só vem preenchida no envio às secções. */
	CountyDescription: string | null;
	MovementCount: number;
	/** "yyyy-MM-dd" */
	FirstMovementDate: string;
	/** "yyyy-MM-dd" */
	LastMovementDate: string;
	Email: string | null;
	HasValidEmail: boolean;
	/** Data/hora ISO do último envio a este destinatário (qualquer período); null se nunca recebeu. */
	LastSendDate: string | null;
}

/** PDF de um destinatário (movements/notification-preview-pdf): o mesmo que segue em anexo. @claude */
export interface IMovementNotificationPdf {
	FileName: string;
	/** PDF em base64 */
	Content: string;
}

/**
 * Assunto e texto do e-mail (movements/notification-default-text). Body é texto simples com "\n".
 * No envio só seguem se forem diferentes do padrão; iguais seguem a null e o BE usa o e-mail de sempre. @claude
 */
export interface IMovementNotificationText {
	Subject: string;
	Body: string;
	/** Ambiente de teste: todos os e-mails vão para TestRecipient e não para os destinatários. */
	TestMode: boolean;
	TestRecipient: string | null;
}

/**
 * O que a pré-visualização mostrou para cada destinatário escolhido. O BE recusa o envio se os
 * movimentos tiverem mudado entretanto. @claude
 */
export interface IMovementNotificationExpected {
	IdTarget: number;
	MovementCount: number;
}

/** Limites do assunto e do texto do e-mail (os mesmos do BE). @claude */
export const MOVEMENT_NOTIFICATION_SUBJECT_MAX = 200;
export const MOVEMENT_NOTIFICATION_BODY_MAX = 5000;

/** Resultado do envio (movements/send-notification-federation|section). @claude */
export interface IMovementNotificationSendResult {
	Sent: number;
	SkippedNoEmail: number;
	Failed: number;
	NotSelected: number;
	FailedDescriptions: Array<string>;
	SkippedDescriptions: Array<string>;
	/** Receberam o e-mail (contam em Sent), mas o registo no histórico falhou. */
	HistoryFailedDescriptions: Array<string>;
	/** Escolhidos que já não tinham movimentos no momento do envio (não enviados). */
	NotFound: number;
	/** Envio feito em modo de teste: os e-mails foram para TestRecipient. */
	TestMode: boolean;
	TestRecipient: string | null;
}
